export default "__VITE_ASSET__CAUBffO___"